import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert'; // Importa el componente de Alerta
import axios from 'axios';
// import axios from 'axios';

const Login: React.FC<{
	setIsLoggedIn: Function;
}> = ({setIsLoggedIn}) => {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [connectionError, setConnectionError] = useState<[boolean, string]>([
		false,
		'',
	]); // Estado para manejar el error de conexión

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		try {
			// const responseLogin = await axios.post(
			// 	// 'http://192.168.100.4:8001/validacion',
			// 	'https://api-ldap.test.uct.cl/validacion',
			// 	{email, password},
			// 	{
			// 		headers: {
			// 			Authorization: `7d668ec5c1f3a94921d321d8d27e4b16`,
			// 		},
			// 		timeout: 2500,
			// 	},
			// );
			// console.log(responseLogin);
			const response = true;
			if (response === true) {
				setIsLoggedIn(true);
				navigate('/home');
			} else {
				setConnectionError([
					true,
					'Email/Rut o contraseña incorrecta, por favor intentalo otra vez.',
				]);
			}
		} catch (error) {
			setConnectionError([
				true,
				'Ocurrio un problema consultando al servidor, por favor intente mas tarde.',
			]);
		}
	};

	return (
		<Container>
			{connectionError[0] && ( // Muestra la alerta en caso de error de conexión
				<Alert
					variant='danger'
					onClose={() => setConnectionError([false, ''])}
					dismissible>
					<Alert.Heading>Error de autenticación</Alert.Heading>
					<p>{connectionError[1]}</p>
				</Alert>
			)}
			<Row className='vh-100 justify-content-center align-items-center'>
				<Col xs={12} md={6} className='p-4'>
					<Card>
						<Card.Body>
							<Card.Title className='title'>Iniciar Sesión</Card.Title>
							<Form onSubmit={handleSubmit}>
								<Form.Group controlId='formEmail'>
									<Form.Label className='header'>Email:</Form.Label>
									<Form.Control
										type='text'
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										className='input'
									/>
								</Form.Group>

								<Form.Group controlId='formPassword'>
									<Form.Label className='header'>Contraseña:</Form.Label>
									<Form.Control
										type='password'
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										className='input'
									/>
								</Form.Group>

								<Button style={{marginTop: 10}} variant='primary' type='submit'>
									Iniciar Sesión
								</Button>
							</Form>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	);
};

export default Login;
